import data from "../../../../../src/SubNav/SubNav.docs.json";
import * as React from 'react';
export default {
  data,
  React
};